import React, { createContext, useContext, ReactNode } from "react";
import { AuthState } from "../hooks/useAuthState";
import { RegisterPayload } from "../services/authService";

interface AuthFormContextValue {
	state: AuthState;
	login: (email: string, password: string) => Promise<void>;
	register: (payload: RegisterPayload) => Promise<void>;
	requestPasswordReset: (email: string) => Promise<void>;
	resetPasswordWithToken: (token: string, newPassword: string) => Promise<void>;
	reset: () => void;
}

const AuthFormContext = createContext<AuthFormContextValue | undefined>(undefined);

interface AuthFormProviderProps {
	children: ReactNode;
	value: AuthFormContextValue;
}

export const AuthFormProvider: React.FC<AuthFormProviderProps> = ({ children, value }) => {
	return <AuthFormContext.Provider value={value}>{children}</AuthFormContext.Provider>;
};

export const useAuthForm = (): AuthFormContextValue => {
	const context = useContext(AuthFormContext);
	if (context === undefined) {
		throw new Error("useAuthForm must be used within an AuthFormProvider");
	}
	return context;
};
